import React from 'react';
import Select from '@components/select';

export default class TagNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cur: props.list[0] || {}
        };
        this.leadTab = this.leadTab.bind(this);
        for (let index = 0; index < props.list.length; index++) {
            if (props.list[index].is_selected == 'yes' || index == 0) {
                this.state.cur = props.list[index];
            }
        }
    }

    leadTab(tagItem) {
        this.setState({
            cur: tagItem
        });
        this.props.gotoTab(tagItem.id);
    }

    render() {
        const { list } = this.props;
        const { cur } = this.state;

        return <Select value={cur} options={list} onChange={this.leadTab} />;
    }
}
